import { useFeatureFlags } from 'core/app/AppContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthorisedSubNavLink } from '../../Auth/AuthorisedSubNavLink';
import { SubNavProps } from '../SubNavLinks';

export function ComplianceSubNav(props: SubNavProps) {
  const { flagEnabled } = useFeatureFlags();
  const { t } = useTranslation('compliance');

  React.useEffect(() => {
    props.setHeading(t('subNav.title'));
  });

  return (
    <>
      {flagEnabled('compliance-send-rules') && (
        <>
          <AuthorisedSubNavLink
            permissions={['ManageClients']}
            to={`/${props.level}/${props.clientId}/compliance/send-rules`}
            icon="list-ul"
            label={t('subNav.sendRules')}
          />
          <AuthorisedSubNavLink
            permissions={['ManageClients']}
            to={`/${props.level}/${props.clientId}/compliance/test-send-rules`}
            icon="tasks"
            label={t('subNav.testSendRules')}
          />
        </>
      )}
      {flagEnabled('compliance-consent-history') && (
        <AuthorisedSubNavLink
          permissions={['ManageClients']}
          to={`/${props.level}/${props.clientId}/compliance/consent-history`}
          icon="handshake-alt"
          label={t('subNav.consentHistory')}
        />
      )}
    </>
  );
}
